module.exports = __webpack_public_path__ + "static/media/logo.a79aea8d.svg";